// extracted by mini-css-extract-plugin
export default {"add-shadow":"SearchResults_add-shadow__-nd6M","toolTip":"SearchResults_toolTip__VUSEs","searchResults":"SearchResults_searchResults__7p9jh"};